<template>
  <div class="resultSignature_warpper">
    <nav-bar titleText="提交结果" titleWeight="bold" @goBack="goBack"></nav-bar>
    <results-page
      @handleOperationClick="handleOperationClick"
      @handleReturnClick="goBack"
      operationDisplab
      operationText="去签署合同"
      returnDisplab
      returnText="返回"
      instructions="支付成功"
      :imgSrc="imgSrc"
    ></results-page>

    <div class="loading" v-if="loading">
      <img src="../../../assets/common/loading.gif"/>
    </div>
  </div>
</template>
<script>
import navBar from "../components/navBar";
import resultsPage from "../components/resultsPage";
export default {
  name: "resultSignature",
  data() {
    return {
      imgSrc: require("../../../assets/debtor/resultOk.png"),
      loading: false,
    };
  },
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    // console.log(this.$route.query.token);
    this.initLoading()
  },
  components: {
    navBar,
    resultsPage,
  },
  methods: {
    goBack() {
      // this.$router.go(-1)
      this.$router.push({
        path: '/debtRelief/wrDebtPersonHome',
        query: {
          token: localStorage.getItem('_token') || this.$route.query.token
        },
      })
    },
   
    initLoading() {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      },2000)
    },
    async handleOperationClick() {
      try {
        this.loading = true
        const res = await this.$api.post('debt/member/agent/contract-list')
        this.loading = false
        if(res.pay_status == 2){
          this.$router.push({
          path: '/agent/contractView',
          query:{
            gopage:2
          }
        //     query: {
        //   agent_contract_id: res.agent_contract_id,
        //   agent_contract_url: res.agent_contract_url,
        // },
        })
        this.loading = false
        }else if(res.pay_status == 1 || res.pay_status == 0){
          this.$toast("合同审批中");
        }
      
      } catch (error) {
        
      }
    },
    handleReturnClick() {
      // TODO 返回首页？
      this.$router.push({
        path: '/debtRelief/wrDebtPersonHome',
        query: {
          token: localStorage.getItem('_token') || this.$route.query.token
        },
      })
    },
  },
};
</script>
<style lang="less">
.resultSignature_warpper {
  padding-top: 88px;
  box-sizing: border-box;
  background-color: #f5f6f7;
  min-height: 100%;
  font-size: 16px;
  color: #333;
  .loading {
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    img {
      width: 35%;
      margin-top: 65%;
    }
  }
}
</style>
